import React, { useContext } from "react";
import { Grid, CardActionArea, Button } from "@mui/material";
import RocketIcon from '@mui/icons-material/Rocket';
import { grey } from "@mui/material/colors";
import DottedTile from "../common/DottedTile";
import Check from "../../auth/ability";
import { CAN, SUBJECTS } from "../../auth/permissions";
import { WizardContext, ACTIONS } from "../wizard/Context";
import useModule from "../../hooks/useModule";
import { MODULES } from "../../services/Constants";

const CreateDeploymentTile = () => {
  const { validateModuleWithMessage } = useModule();
  const { dispatch } = useContext(WizardContext);
  return (
    <Check I={CAN.CREATE} a={SUBJECTS.DEPLOYMENT}>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }}>
        <CardActionArea
          onClick={() => {
            if (validateModuleWithMessage(MODULES.OTA)) {
              dispatch({
                type: ACTIONS.SHOW_SOFTWARE_WIZARD,
              });
            }
          }}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<RocketIcon />}
            sx={{ width: "100%",  borderRadius: '6px' }}
          >
            Create a Deployment
          </Button>
        </CardActionArea>
      </Grid>
    </Check>
  );
};

export default CreateDeploymentTile;
